export default __webpack_public_path__ + "static/media/colle_preview.72062dff.png";